import { Injectable } from '@angular/core';
import { NotificationCenterEntry, NotificationCenterUpdate } from '@weavix/models/src/notification/notification-center';
import { Topic } from '@weavix/models/src/topic/topic';
import { HttpService } from 'weavix-shared/services/http.service';
import { PubSubService } from 'weavix-shared/services/pub-sub.service';
import { uniqBy } from 'lodash';
import { BehaviorSubject } from 'rxjs';

export interface FacilityAlertPersonUpdateRequest {
    read?: boolean;
    removed?: boolean;
}

export const openNotification$ = new BehaviorSubject<string | NotificationCenterEntry>(null);
export const closeNotification$ = new BehaviorSubject<number>(null);

export const updateNotificationIcon$ = new BehaviorSubject<any>(null);
export const closeNotificationDropdown$ = new BehaviorSubject<any>(null);

@Injectable({
    providedIn: 'root',
})
export class NotificationCenterService {
    constructor(
        private readonly httpService: HttpService,
        private readonly pubSubService: PubSubService,
    ) { }

    currentNotifications: NotificationCenterEntry[];

    static api = (id?: string) => id ? `/core/notification-center-entries/${id}` : `/core/me/notification-center-entries`;
    static facilityAlertApi = (id?: string, accountId?: string) => id ? `/a/${accountId}/track/facility-alerts/${id}` : `/a/${accountId}/track/facility-alerts`;

    async getById(component: any, id: string) {
        return this.httpService.get<NotificationCenterEntry>(component, NotificationCenterService.api(id));
    }

    async getAll(component: any) {
        const test = await this.httpService.get<NotificationCenterEntry[]>(component, NotificationCenterService.api());
        // handling a bug where alerts are duplicated with different account IDs.
        // Ticket for fix is in, but this should delete the duplicates if there are any
        const returning = uniqBy(test, m => m.id);
        this.currentNotifications = returning;
        return returning;
    }

    async update(component: any, id: string, notification: NotificationCenterUpdate) {
        return this.httpService.put(component, NotificationCenterService.api(id), notification);
    }

    async updateFacilityAlert(component: any, id: string, accountId: string, updateRequest: FacilityAlertPersonUpdateRequest) {
        return this.httpService.put(component, NotificationCenterService.facilityAlertApi(id, accountId), updateRequest);
    }

    subscribeNotificationCreated(component: any, userId: string) {
        return this.pubSubService.subscribe<NotificationCenterEntry>(component, Topic.UserNotificationCreated, [userId]);
    }
}
